import { FC } from 'react'
import { ValidationModal } from '../../shared'

export interface SessionLogoutConfirmModalProps {
  display: boolean
  deviceLabel: string
  ipAddress?: string
  bulk?: boolean
  disableSubmit?: boolean
  onConfirm: () => void
  onClose: () => void
}

export const SessionLogoutConfirmModal: FC<SessionLogoutConfirmModalProps> = ({
  display,
  deviceLabel,
  ipAddress,
  bulk = false,
  disableSubmit = false,
  onConfirm,
  onClose,
}) => {
  const title = bulk ? 'Déconnecter tous les autres appareils ?' : 'Déconnecter cet appareil ?'

  const targetLabel = ipAddress ? `${deviceLabel} · ${ipAddress}` : deviceLabel

  const description = bulk
    ? `Toutes les sessions actives, sauf celle de cet appareil, seront déconnectées. ${targetLabel} restera connecté.`
    : `${targetLabel} sera déconnecté. Cet appareil devra se reconnecter pour accéder de nouveau à votre compte.`

  return (
    <ValidationModal
      display={display}
      title={title}
      description={description}
      icon="power"
      confirmLabel="Déconnecter"
      cancelLabel="Annuler"
      confirmTheme="invalid"
      disableSubmit={disableSubmit}
      onSubmit={onConfirm}
      onClose={onClose}
      testId="modal-session_logout"
    />
  )
}
